export default function SectionAbout() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          了解911吃瓜网的使命与初心
        </p>
        <div className="bg-background-100 rounded-2xl border border-secondary-200/60 p-8 md:p-10">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="flex-shrink-0">
              <span className="w-16 h-16 flex items-center justify-center bg-primary-500 text-background-50 rounded-2xl">
                <span className="font-heading text-xl font-bold">911</span>
              </span>
            </div>
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                911吃瓜网成立于2023年，是国内领先的独立黑料信息聚合平台。我们致力于打破信息壁垒，
                为广大吃瓜群众提供真实、全面、及时的内幕曝光与负面新闻资讯。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                平台内容覆盖明星黑料、网红翻车、娱乐圈潜规则、品牌负面、商业内幕等多个领域，
                日均更新数十条独家猛料。我们坚持「让真相不再沉默」的运营理念，
                通过匿名投稿机制与多源交叉验证，确保每一条信息的可信度与传播价值。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                目前911吃瓜网月活跃用户已突破百万，成为中文互联网最具影响力的吃瓜社区之一。
                我们欢迎每一位热爱真相、关注公共议题的用户加入，一起守护信息透明的力量。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}